import { useEffect, useState } from "react";
import "./index.css";

import { CustomTable } from "../../components/custom-table";
import { Sidebar } from "../../components/sidebar";
import { Snackbar } from "../../components/snackbar";
import { Wrapper } from "../../components/wrapper";
import { findById, findCar, registerCar, updateCar } from "../../services/car";
import { findCustomerByRut } from "../../services/customer";
import {
  CUSTOMER_FOUND,
  DEFAULT_SNACK,
  DUPLICATE_LICENSE,
  EMPTY_CREDENTIALS,
  ERROR_CAR_REGISTER,
  EXISTING_CAR,
  SUCCESS_CAR_REGISTER,
} from "../../utils/snacks";
import { DEFAULT_CAR, SERVICES_COLUMNS } from "../../utils/states";
import car from "./data.json";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import AlertDialog from "../../components/alert-dialog";
import { useLocation, useNavigate } from "react-router-dom";
import { useDirty } from "../../context/dirty";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import SpeedIcon from "@mui/icons-material/Speed";
import BadgeIcon from "@mui/icons-material/Badge";
import { exportPdf } from "../../services/files";
import { API } from "../../services/api";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import BuildIcon from "@mui/icons-material/Build";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { createCustomer } from "../../services/customer";
import axios from "axios";
import config from "../../config/api.config";
import { sendWhatsAppPDF, getWhatsAppStatus } from "../../services/whatsapp";

const validateRut = (rut) => {
  const cleanRut = rut.replace(/[.-]/g, "");
  if (!/^\d{7,8}[\dkK]$/.test(cleanRut)) return false;

  const body = cleanRut.slice(0, -1);
  const dv = cleanRut.slice(-1).toUpperCase();

  let sum = 0;
  let multiplier = 2;

  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const expectedDv = 11 - (sum % 11);
  const calculatedDv =
    expectedDv === 11 ? "0" : expectedDv === 10 ? "K" : expectedDv.toString();

  return dv === calculatedDv;
};

const formatRut = (value) => {
  const cleaned = value.replace(/[^0-9kK]/g, "");
  if (cleaned.length <= 1) return cleaned;

  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);

  let formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${formatted}-${dv}`;
};

const formatPhone = (value) => {
  const cleaned = value.replace(/\D/g, "");
  if (cleaned.length === 0) return "";

  if (cleaned.startsWith("56")) {
    if (cleaned.length <= 2) return "+56";
    if (cleaned.length <= 3) return `+56 ${cleaned.slice(2)}`;
    return `+56 ${cleaned.slice(2, 3)} ${cleaned.slice(3, 11)}`;
  }

  if (cleaned.startsWith("9")) {
    if (cleaned.length === 1) return "+56 9";
    return `+56 9 ${cleaned.slice(1, 9)}`;
  }

  return `+56 ${cleaned.slice(0, 1)} ${cleaned.slice(1, 9)}`;
};

const validatePhone = (phone) => {
  const cleaned = phone.replace(/\D/g, "");
  return cleaned.length >= 10 && cleaned.length <= 11;
};

export const Newfile = () => {
  return (
    <div className="flex w-full min-h-screen">
      <Sidebar />
      <div className="flex-1 w-full p-4 bg-sidebar-bg">
        <Wrapper>
          <Form />
        </Wrapper>
      </div>
    </div>
  );
};

export const Form = () => {
  const [data, setData] = useState(DEFAULT_CAR);
  const [snack, setSnackbar] = useState(DEFAULT_SNACK);
  const [showTable, setShowTable] = useState(false);
  const [services, setServices] = useState(car.services);
  const [open, setOpen] = useState(false);
  const [dataInRow, setDataInRow] = useState();
  const [searchedRegister, setSearchedRegister] = useState(false);
  const [idRegister, setIdRegister] = useState(null);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [customerFound, setCustomerFound] = useState(false);
  const [motorTypes, setMotorTypes] = useState([
    { value: "", label: "Cargando..." },
  ]);
  const location = useLocation();
  const navigate = useNavigate();
  const { isDirty, setDirty } = useDirty();

  const markDirty = () => setDirty(true);
  const markClean = () => setDirty(false);

  useEffect(() => {
    if (!isDirty) return;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isDirty]);

  useEffect(() => {
    return () => setDirty(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetSnackbar = () => {
    setTimeout(() => {
      setSnackbar(DEFAULT_SNACK);
    }, 2000);
  };

  const setServicesAndDirty = (next) => {
    setServices(next);
    markDirty();
  };

  useEffect(() => {
    const fetchMotorTypes = async () => {
      try {
        const { data: response } = await axios.get(
          `${config.apiUrl}/service-list`
        );
        if (response.success && response.data) {
          const types = [
            { value: "", label: "Seleccione un tipo" },
            ...response.data.map((list) => ({
              value: list.name,
              label: list.name,
            })),
          ];
          setMotorTypes(types);
          console.log("🚗 Tipos de motor cargados:", types.length - 1);
        }
      } catch (err) {
        console.error("Error al cargar tipos de motor:", err);
        setMotorTypes([{ value: "", label: "Error al cargar tipos" }]);
      }
    };

    fetchMotorTypes();

  }, []);

  useEffect(() => {
    if (location.search === "") {
      setServices([]); 
      setData(DEFAULT_CAR);
      setShowTable(false);
    }
  }, [location.search]);

  useEffect(() => {
    if (window.location.search) {
      async function fetchRegister() {
        try {
          let id = window.location.search.split("?")[1];
          let fileRegister = await findById(id);
          let fileServices = fileRegister.services || [];

          setData({
            ...data,
            license: fileRegister.license,
            customer_name: fileRegister.customer_name,
            customer_id: fileRegister.customer_id,
            phone: fileRegister.phone,
            brand: fileRegister.brand,
            model: fileRegister.model,
            kms: fileRegister.kms,
            date: fileRegister.date,
            motor_type: fileRegister.motor_type || "",
            year: fileRegister.year || "",
          });
          setServices(fileServices);
          setShowTable(true);
          setSearchedRegister(true);
          setIdRegister(id);
        } catch (err) {
          console.log(err);
        }
      }
      fetchRegister();
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = async ({ target: { name, value } }) => {
    markDirty();
    let formattedValue = value;

    if (name === "customer_id") {
      formattedValue = formatRut(value);
    } else if (name === "phone") {
      formattedValue = formatPhone(value);
    } else if (name === "license") {
      formattedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    }

    setData({
      ...data,
      [name]: formattedValue,
    });

    // Si cambia el motor_type y NO estamos editando, cargar servicios de la plantilla
    if (name === "motor_type" && !searchedRegister && formattedValue) {
      try {
        const { data: response } = await axios.get(`${config.apiUrl}/service-list`);
        if (response.success && response.data) {
          const selectedList = response.data.find(list => list.name === formattedValue);
          if (selectedList && selectedList.services) {
            const servicesWithReset = selectedList.services.map(service => ({
              ...service,
              date: "",
              worker: "-",
              nextService: "",
              nextServiceNum: 0,
              reset: false,
            }));
            setServices(servicesWithReset);
            setShowTable(true);
          } else {
            setServices([]);
            setShowTable(false);
          }
        }
      } catch (err) {
        console.error("Error al cargar servicios del motor_type:", err);
      }
    }

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const handleBlur = (name) => {
    setTouched({
      ...touched,
      [name]: true,
    });

    validateField(name, data[name]);
  };

  const getFieldError = (name, value, strict = true) => {
    switch (name) {
      case "customer_id":
        if (!value) return "El RUT es requerido";
        if (strict && !validateRut(value)) return "RUT inválido";
        return null;
      case "phone":
        if (!value) return "El teléfono es requerido";
        if (strict && !validatePhone(value)) return "Teléfono inválido (debe tener 8-9 dígitos)";
        return null;
      case "license":
        if (!value) return "La patente es requerida";
        return null;
      case "kms":
        if (!value) return "El kilometraje es requerido";
        if (parseInt(value) < 0) return "El kilometraje no puede ser negativo";
        return null;
      default:
        if (!value && name !== "motor_type" && name !== "year") return "Este campo es requerido";
        return null;
    }
  };

  const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const validateForm = () => {
    const requiredFields = [
      "license",
      "customer_name",
      "customer_id",
      "phone",
      "brand",
      "model",
      "kms",
    ];

    // When editing, only check fields are not empty (no format validation)
    const strict = !searchedRegister;

    let isValid = true;
    const newErrors = {};
    const newTouched = {};

    requiredFields.forEach((field) => {
      newTouched[field] = true;
      const error = getFieldError(field, data[field], strict);
      newErrors[field] = error;
      if (error) {
        isValid = false;
      }
    });

    setErrors(newErrors);
    setTouched(newTouched);
    return isValid;
  };

  const searchCustomerByRut = async (rut) => {
    if (!rut || !validateRut(rut) || searchedRegister) return;
    try {
      const customer = await findCustomerByRut(rut);
      if (customer) {
        setData((prev) => ({
          ...prev,
          customer_name: customer.name,
          phone: customer.phone,
          customerId: customer._id,
        }));
        setCustomerFound(true);
        setSnackbar(CUSTOMER_FOUND);
        resetSnackbar();
      } else {
        setCustomerFound(false);
      }
    } catch (err) {
      console.log("Cliente no encontrado, se creará uno nuevo");
      setCustomerFound(false);
    }
  };

  const handleRutBlur = () => {
    handleBlur("customer_id");
    searchCustomerByRut(data.customer_id);
  };

  useEffect(() => {
    if (!data.customer_id || !validateRut(data.customer_id) || searchedRegister) return;
    const t = setTimeout(() => searchCustomerByRut(data.customer_id), 500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.customer_id, searchedRegister]);

  const handleCreateCustomer = async () => {
    if (!data.customer_id || !data.customer_name || !data.phone) {
      setSnackbar({
        visible: true,
        severity: "error",
        message: "Complete RUT, nombre y teléfono para crear el cliente",
      });
      resetSnackbar();
      return;
    }

    if (!validateRut(data.customer_id)) {
      setSnackbar({
        visible: true,
        severity: "error",
        message: "RUT inválido",
      });
      resetSnackbar();
      return;
    }

    if (!validatePhone(data.phone)) {
      setSnackbar({
        visible: true,
        severity: "error",
        message: "Teléfono inválido",
      });
      resetSnackbar();
      return;
    }

    try {
      const newCustomer = await createCustomer({
        customer_id: data.customer_id,
        name: data.customer_name,
        phone: data.phone,
      });

      setData({
        ...data,
        customerId: newCustomer._id,
      });
      setCustomerFound(true);
      setSnackbar({
        visible: true,
        severity: "success",
        message: "Cliente creado exitosamente",
      });
      resetSnackbar();
    } catch (err) {
      console.error("Error al crear cliente:", err);
      setSnackbar({
        visible: true,
        severity: "error",
        message:
          err.response?.data?.message ||
          "Error al crear el cliente. Puede que ya exista.",
      });
      resetSnackbar();
    }
  };

  const handleLicenseBlur = async () => {
    handleBlur("license");

    if (data.license && !searchedRegister) {
      try {
        const existingCar = await findCar({
          license: data.license.toUpperCase(),
        });

        if (existingCar) {
          setData({
            ...data,
            customer_name: existingCar.customer_name,
            customer_id: existingCar.customer_id,
            phone: existingCar.phone,
            brand: existingCar.brand,
            model: existingCar.model,
            motor_type: existingCar.motor_type || "",
            year: existingCar.year || "",
            customerId: existingCar.customerId || "",
          });
          setCustomerFound(true);
          setSnackbar({
            visible: true,
            severity: "info",
            message: "Vehículo encontrado, datos autocompletados",
          });
          resetSnackbar();
        }
      } catch (err) {
        console.log("Vehículo no encontrado");
      }
    }
  };

  const handleServices = async (e) => {
    e.preventDefault();

    const fieldLabels = {
      license: "Patente",
      customer_name: "Nombre",
      customer_id: "RUT",
      phone: "Teléfono",
      brand: "Marca",
      model: "Modelo",
      kms: "Kilometraje",
    };

    if (!validateForm()) {
      const requiredFields = ["license", "customer_name", "customer_id", "phone", "brand", "model", "kms"];
      const failedFields = requiredFields
        .filter((field) => getFieldError(field, data[field]))
        .map((field) => fieldLabels[field] || field);

      setSnackbar({
        visible: true,
        severity: "error",
        message: `Errores en: ${failedFields.join(", ")}`,
      });
      resetSnackbar();
      return;
    }

    if (!searchedRegister) {
      let isDuplicated = await findCar({ license: data.license });

      if (isDuplicated && !customerFound) {
        setErrors({
          ...errors,
          license: "Esta patente ya está registrada",
        });
        setSnackbar(DUPLICATE_LICENSE);
        resetSnackbar();
        return;
      }
    }

    if (services.length === 0) {
      try {
        const { data: response } = await axios.get(`${config.apiUrl}/service-list`);
        if (response.success && response.data) {
          const selectedList = response.data.find(list => list.name === data.motor_type);
          
          if (selectedList && selectedList.services && selectedList.services.length > 0) {
            const servicesWithReset = selectedList.services.map(service => ({
              ...service,
              date: "",
              worker: data.workerName || "-",
              nextService: "",
              nextServiceNum: 0,
              reset: false,
            }));
            setServices(servicesWithReset);
            setShowTable(true);
            return;
          } else {
            setServices([]);
            setShowTable(true);
            setSnackbar({
              visible: true,
              severity: "warning",
              message: `No hay servicios predefinidos para ${data.motor_type || 'este tipo'}. Agrega servicios manualmente.`,
            });
            resetSnackbar();
            console.log(`⚠️ No hay servicios configurados para ${data.motor_type}, mostrando tabla vacía`);
            return;
          }
        }
      } catch (err) {
        console.error("Error al cargar servicios:", err);
        setServices([]);
        setShowTable(true);
        setSnackbar({
          visible: true,
          severity: "warning",
          message: "No se pudieron cargar servicios. Agrega servicios manualmente.",
        });
        resetSnackbar();
        return;
      }
    }

    const updatedServices = services.map(service => ({
      ...service,
      date: service.date || new Date().toLocaleDateString("es-CL"),
      worker: service.worker === "-" ? (data.workerName || "-") : service.worker,
    }));

    setServices(updatedServices);
    setShowTable(true);

    // When editing and table is already visible, save directly
    if (searchedRegister && showTable) {
      try {
        await updateCar(
          {
            ...data,
            date: new Date().toLocaleDateString("es-CL"),
            services: updatedServices,
          },
          idRegister
        );
        markClean();
        setSnackbar(SUCCESS_CAR_REGISTER);
        resetSnackbar();
      } catch (err) {
        console.log("Error al actualizar:", err);
        setSnackbar(ERROR_CAR_REGISTER);
        resetSnackbar();
      }
    }
  };

  const onNewRegister = async (e, services) => {
    e.preventDefault();
    try {
      let newUser = await registerCar({
        ...data,
        services: services,
      });
      if (newUser.code === 409) {
        setSnackbar(EXISTING_CAR);
        resetSnackbar();
        return;
      }
      markClean();
      setData(DEFAULT_CAR);
      setSnackbar(SUCCESS_CAR_REGISTER);
      resetSnackbar();
      setShowTable(false);
      setTimeout(() => {
        navigate("/dashboard");
      }, 2000);
    } catch (e) {
      console.log("e: ", e);
      setSnackbar(ERROR_CAR_REGISTER);
      resetSnackbar();
    }
  };

  const onUpdateRegister = async (e, services) => {
    e.preventDefault();
    try {
      await updateCar(
        {
          ...data,
          date: new Date().toLocaleDateString("es-CL"),
          services: services,
        },
        idRegister
      );
      markClean();
      setSnackbar(SUCCESS_CAR_REGISTER);
      resetSnackbar();
    } catch (e) {
      console.log("e: ", e);
      setSnackbar(ERROR_CAR_REGISTER);
      resetSnackbar();
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleReset = () => {
    const idx = services.findIndex(
      (s) => s === dataInRow || (s.title === dataInRow.title && s.interval === dataInRow.interval)
    );
    if (idx === -1) return;

    let newservices = [...services];
    let interval = Number(newservices[idx].intervalNum) || 0;

    if (interval > 0) {
      let newService = Number(data.kms) + interval;
      newservices[idx].nextService = trimNumber(newService);
      newservices[idx].nextServiceNum = newService;
    }

    newservices[idx].reset = true;
    newservices[idx].date = new Date().toLocaleDateString("es-CL");
    const defaults = getDefaultServiceRow();
    if (defaults.worker) newservices[idx].worker = defaults.worker;

    setServicesAndDirty(newservices);
    handleClose();
  };

  const handleRevisado = (rowData) => {
    const idx = services.findIndex(
      (s) => s === rowData || (s.title === rowData.title && s.interval === rowData.interval)
    );
    if (idx === -1) return;

    let newservices = [...services];
    newservices[idx].reset = !newservices[idx].reset;
    newservices[idx].date = new Date().toLocaleDateString("es-CL");

    setServicesAndDirty(newservices);
  };

  const trimNumber = (n) =>
    n.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");

  const getDefaultServiceRow = () => {
    let workerName = "";
    try {
      const raw = localStorage.getItem("user");
      if (raw) {
        const u = JSON.parse(raw);
        workerName = `${u?.name || ""} ${u?.last_name || ""}`.trim();
      }
    } catch (_) {}
    return {
      date: new Date().toLocaleDateString("es-CL"),
      worker: workerName || "-",
    };
  };

  let actions = {
    icon: () => <RestartAltIcon />,
    onClick: (event, rowData) => {
      const intervalNum = Number(rowData.intervalNum) || 0;
      if (intervalNum > 0) {
        setDataInRow(rowData);
        if (!rowData.reset) {
          handleOpen();
        }
      }
    },
  };

  function downloadPDF() {
    exportPdf(SERVICES_COLUMNS, services, data.kms, data);
  }

  async function openWs() {
    if (!idRegister || !data.phone) return;

    // Try Baileys first
    try {
      const status = await getWhatsAppStatus();
      if (status.status === "connected") {
        await sendWhatsAppPDF(idRegister, data.phone, data.kms);
        setSnackbar({
          visible: true,
          severity: "success",
          message: "PDF enviado por WhatsApp correctamente",
        });
        resetSnackbar();
        return;
      }
    } catch (err) {
      console.log("Baileys no disponible, usando wa.me fallback");
    }

    // Fallback: open wa.me with a simple message
    let phoneNumber = data.phone.replace(/[\s\-\+\(\)]/g, "");
    const licensePlate = (data.license || "").toUpperCase();
    let message = `Hola, le enviamos la pauta de mantención de su vehículo ${licensePlate}. Para más información, contáctenos. - GaragePro`;
    let encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  }

  return (
    <>
      <div className="w-full max-w-7xl mx-auto p-6">
        {showTable && (
          <div className="mb-8">
            <ShareCard
              onDownloadPDF={downloadPDF}
              onOpenWhatsApp={openWs}
              hasPhone={!!data.phone}
              hasRegister={!!idRegister}
            />
          </div>
        )}

        <FormCard
          data={data}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleLicenseBlur={handleLicenseBlur}
          handleRutBlur={handleRutBlur}
          handleServices={handleServices}
          searchedRegister={searchedRegister}
          errors={errors}
          touched={touched}
          customerFound={customerFound}
          isDirty={isDirty}
          onCreateCustomer={handleCreateCustomer}
          motorTypes={motorTypes}
        />

        {showTable && (
          <div className="mt-8">
            <CustomTable
              data={services}
              columns={SERVICES_COLUMNS}
              title={"Servicios de Mantención"}
              kms={data.kms}
              values={services}
              setData={setServicesAndDirty}
              pageSize={car.services.length}
              handleSubmit={searchedRegister ? onUpdateRegister : onNewRegister}
              actions={actions}
              onRevisado={handleRevisado}
              file={data}
              defaultRow={getDefaultServiceRow()}
            />
          </div>
        )}
      </div>

      <Snackbar
        severity={snack.severity}
        message={snack.message}
        visible={snack.visible}
      />
      <AlertDialog
        open={open}
        title="¿Estás seguro?"
        body={""}
        handleClose={handleClose}
        handleConfirm={handleReset}
        ConfirmButtonText={"Reset"}
      />
    </>
  );
};

const ShareCard = ({
  onDownloadPDF,
  onOpenWhatsApp,
  hasPhone,
  hasRegister,
}) => {
  return (
    <div className="bg-sidebar-bg rounded-xl p-6 border border-sidebar-accent">
      <h3 className="text-white text-lg font-semibold mb-4">
        Compartir Servicio PDF
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="space-y-2">
          <p className="text-gray-400 text-xs">Opciones:</p>
          <ol className="space-y-1.5 text-gray-500 text-xs">
            <li className="flex items-start gap-2">
              <span className="text-blue-400 font-semibold">1.</span>
              <span>Descargar PDF localmente</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-blue-400 font-semibold">2.</span>
              <span>Enviar PDF directo por WhatsApp al cliente</span>
            </li>
          </ol>
        </div>

        <button
          onClick={onDownloadPDF}
          className="flex flex-col items-center justify-center gap-3 p-6 bg-sidebar-accent rounded-lg hover:bg-sidebar-hover transition-all duration-200 group border border-sidebar-accent hover:border-blue-500/50"
        >
          <div className="p-3 bg-blue-500/10 rounded-full group-hover:bg-blue-500/20 transition-colors">
            <PictureAsPdfIcon
              className="text-blue-400 group-hover:scale-110 transition-transform"
              sx={{ fontSize: 32 }}
            />
          </div>
          <div className="text-center">
            <p className="text-white font-medium text-sm">Documento Servicio</p>
            <p className="text-gray-500 text-xs mt-1">Descargar PDF</p>
          </div>
        </button>

        <button
          onClick={onOpenWhatsApp}
          disabled={!hasPhone || !hasRegister}
          className={`flex flex-col items-center justify-center gap-3 p-6 rounded-lg transition-all duration-200 group border ${
            hasPhone && hasRegister
              ? "bg-sidebar-accent hover:bg-sidebar-hover border-sidebar-accent hover:border-green-500/50 cursor-pointer"
              : "bg-sidebar-accent/30 border-sidebar-accent cursor-not-allowed opacity-50"
          }`}
        >
          <div
            className={`p-3 rounded-full transition-colors ${
              hasPhone && hasRegister
                ? "bg-green-500/10 group-hover:bg-green-500/20"
                : "bg-gray-500/10"
            }`}
          >
            <WhatsAppIcon
              className={`transition-transform ${
                hasPhone && hasRegister
                  ? "text-green-400 group-hover:scale-110"
                  : "text-gray-500"
              }`}
              sx={{ fontSize: 32 }}
            />
          </div>
          <div className="text-center">
            <p className="text-white font-medium text-sm">Enviar por WhatsApp</p>
            <p className="text-gray-500 text-xs mt-1">
              {!hasPhone
                ? "Agrega teléfono"
                : !hasRegister
                ? "Guarda registro"
                : "Enviar mensaje"}
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};

// MOTOR_TYPES ahora se carga dinámicamente desde el backend en el componente Form

const FormCard = ({
  data,
  handleChange,
  handleBlur,
  handleLicenseBlur,
  handleRutBlur,
  handleServices,
  searchedRegister,
  errors,
  touched,
  customerFound,
  isDirty = false,
  onCreateCustomer,
  motorTypes,
}) => {
  return (
    <div className="bg-sidebar-bg rounded-xl border border-sidebar-accent overflow-hidden">
      <div className="bg-sidebar-accent px-6 py-4 border-b border-sidebar-accent">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-500/10 rounded-lg">
            <DirectionsCarIcon
              className="text-blue-400"
              sx={{ fontSize: 24 }}
            />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white">
              {searchedRegister ? "Editar Registro" : "Nuevo Registro"}
            </h2>
            <p className="text-gray-400 text-sm mt-0.5">
              Complete los datos del vehículo
            </p>
          </div>
        </div>
      </div>

      {(() => {
        const isRutValid =
          !!data.customer_id && validateRut(data.customer_id);
        const lockCustomerFields = !searchedRegister && !isRutValid;
        return (
      <form className="p-6" onSubmit={handleServices}>
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              icon={DirectionsCarIcon}
              label="Patente del vehículo"
              name="license"
              value={data.license}
              onChange={handleChange}
              onBlur={handleLicenseBlur}
              placeholder="Ej: ABCD12"
              required
              error={touched.license ? errors.license : null}
              maxLength={6}
              helperText="Se autocompletarán los datos si existe"
            />
            <div>
              <InputField
                icon={BadgeIcon}
                label="RUT del cliente"
                name="customer_id"
                value={data.customer_id}
                onChange={handleChange}
                onBlur={handleRutBlur}
                placeholder="12.345.678-9"
                required
                error={touched.customer_id ? errors.customer_id : null}
                helperText="Se autocompletarán los datos si existe"
              />
              {!searchedRegister &&
                !customerFound &&
                isRutValid &&
                data.customer_name &&
                data.phone && (
                  <button
                    type="button"
                    onClick={onCreateCustomer}
                    className="mt-2 w-full px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-all flex items-center justify-center gap-2"
                  >
                    <PersonAddIcon sx={{ fontSize: 18 }} />
                    Crear Cliente Nuevo
                  </button>
                )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              icon={PersonIcon}
              label="Nombre del cliente"
              name="customer_name"
              value={data.customer_name}
              onChange={handleChange}
              onBlur={() => handleBlur("customer_name")}
              placeholder="Nombre completo"
              required
              disabled={lockCustomerFields}
              error={touched.customer_name ? errors.customer_name : null}
              helperText={lockCustomerFields ? "Ingresa primero un RUT válido" : null}
            />
            <InputField
              icon={PhoneIcon}
              label="Teléfono"
              name="phone"
              value={data.phone}
              onChange={handleChange}
              onBlur={() => handleBlur("phone")}
              placeholder="+56 9 1234 5678"
              required
              disabled={lockCustomerFields}
              error={touched.phone ? errors.phone : null}
              helperText={lockCustomerFields ? "Ingresa primero un RUT válido" : "Formato: +56 9 XXXX XXXX"}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              icon={DirectionsCarIcon}
              label="Marca del vehículo"
              name="brand"
              value={data.brand}
              onChange={handleChange}
              onBlur={() => handleBlur("brand")}
              placeholder="Toyota, Ford, etc."
              required
              error={touched.brand ? errors.brand : null}
            />
            <InputField
              icon={DirectionsCarIcon}
              label="Modelo del vehículo"
              name="model"
              value={data.model}
              onChange={handleChange}
              onBlur={() => handleBlur("model")}
              placeholder="Corolla, Focus, etc."
              required
              error={touched.model ? errors.model : null}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <InputField
              icon={SpeedIcon}
              label="Kilometraje"
              name="kms"
              value={data.kms}
              onChange={handleChange}
              onBlur={() => handleBlur("kms")}
              placeholder="50000"
              type="number"
              required
              error={touched.kms ? errors.kms : null}
            />
            <SelectField
              icon={BuildIcon}
              label="Tipo de Motor"
              name="motor_type"
              value={data.motor_type || ""}
              onChange={handleChange}
              options={motorTypes}
              helperText="Campo opcional"
            />
            <InputField
              icon={CalendarTodayIcon}
              label="Año"
              name="year"
              value={data.year || ""}
              onChange={handleChange}
              placeholder="2020"
              type="number"
              min="1900"
              max={new Date().getFullYear() + 1}
              helperText="Campo opcional"
            />
          </div>

          <div className="pt-4">
            <button
              type="submit"
              className={`w-full px-6 py-3 bg-gradient-to-r text-white font-medium rounded-lg transition-all duration-200 hover:shadow-lg flex items-center justify-center gap-2 group ${
                isDirty
                  ? "from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 hover:shadow-orange-500/20"
                  : "from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 hover:shadow-blue-500/20"
              }`}
            >
              <DirectionsCarIcon className="group-hover:scale-110 transition-transform" />
              {searchedRegister
                ? isDirty
                  ? "Guardar cambios"
                  : "Actualizar Revisión"
                : "Iniciar Revisión"}
              {isDirty && (
                <span className="ml-2 inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded-full bg-white/20">
                  Sin guardar
                </span>
              )}
            </button>
          </div>
        </div>
      </form>
        );
      })()}
    </div>
  );
};

const InputField = ({
  icon: Icon,
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  required = false,
  error = null,
  helperText = null,
  maxLength,
  min,
  max,
  disabled = false,
}) => {
  const hasError = !!error;
  const isValid = !hasError && value && required;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-400 mb-2">
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <Icon
            className={`${
              hasError
                ? "text-red-400"
                : isValid
                ? "text-green-400"
                : "text-gray-500"
            }`}
            sx={{ fontSize: 20 }}
          />
        </div>
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          min={min}
          max={max}
          disabled={disabled}
          className={`w-full pl-11 pr-11 py-3 bg-white rounded-lg text-black placeholder-gray-500 focus:outline-none transition-all border-2 ${
            disabled
              ? "bg-gray-100 cursor-not-allowed"
              : hasError
              ? "border-red-500 focus:border-red-600 focus:ring-2 focus:ring-red-500/20"
              : isValid
              ? "border-green-500 focus:border-green-600 focus:ring-2 focus:ring-green-500/20"
              : "border-sidebar-accent focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
          }`}
        />
        {hasError && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            <ErrorIcon className="text-red-400" sx={{ fontSize: 20 }} />
          </div>
        )}
        {isValid && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            <CheckCircleIcon className="text-green-400" sx={{ fontSize: 20 }} />
          </div>
        )}
      </div>
      {(error || helperText) && (
        <div className="mt-1.5 flex items-start gap-1.5">
          {error ? (
            <>
              <ErrorIcon
                className="text-red-400 flex-shrink-0 mt-0.5"
                sx={{ fontSize: 14 }}
              />
              <p className="text-xs text-red-400">{error}</p>
            </>
          ) : (
            <p className="text-xs text-gray-500 ml-5">{helperText}</p>
          )}
        </div>
      )}
    </div>
  );
};

const SelectField = ({
  icon: Icon,
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  helperText = null,
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-400 mb-2">
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none z-10">
          <Icon className="text-gray-500" sx={{ fontSize: 20 }} />
        </div>
        <select
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          className="w-full pl-11 pr-4 py-3 bg-white rounded-lg text-black focus:outline-none transition-all border-2 border-sidebar-accent focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 appearance-none cursor-pointer"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <svg
            className="w-5 h-5 text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>
      {helperText && (
        <div className="mt-1.5">
          <p className="text-xs text-gray-500 ml-5">{helperText}</p>
        </div>
      )}
    </div>
  );
};
